// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/action/v1/action.proto" (package "c1.api.action.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { ActionService } from "./action";
import type { ActionServiceSearchResponse } from "./action";
import type { ActionServiceSearchRequest } from "./action";
import type { ActionServiceDeleteResponse } from "./action";
import type { ActionServiceDeleteRequest } from "./action";
import type { ActionServiceUpdateResponse } from "./action";
import type { ActionServiceUpdateRequest } from "./action";
import type { ActionServiceListResponse } from "./action";
import type { ActionServiceListRequest } from "./action";
import type { ActionServiceGetResponse } from "./action";
import type { ActionServiceGetRequest } from "./action";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ActionServiceCreateResponse } from "./action";
import type { ActionServiceCreateRequest } from "./action";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.action.v1.ActionService
 */
export interface IActionServiceClient {
    /**
     * Create a new action
     *
     * @generated from protobuf rpc: Create
     */
    create(input: ActionServiceCreateRequest, options?: RpcOptions): UnaryCall<ActionServiceCreateRequest, ActionServiceCreateResponse>;
    /**
     * Get an action by ID
     *
     * @generated from protobuf rpc: Get
     */
    get(input: ActionServiceGetRequest, options?: RpcOptions): UnaryCall<ActionServiceGetRequest, ActionServiceGetResponse>;
    /**
     * List actions
     *
     * @generated from protobuf rpc: List
     */
    list(input: ActionServiceListRequest, options?: RpcOptions): UnaryCall<ActionServiceListRequest, ActionServiceListResponse>;
    /**
     * Update an action
     *
     * @generated from protobuf rpc: Update
     */
    update(input: ActionServiceUpdateRequest, options?: RpcOptions): UnaryCall<ActionServiceUpdateRequest, ActionServiceUpdateResponse>;
    /**
     * Delete an action
     *
     * @generated from protobuf rpc: Delete
     */
    delete(input: ActionServiceDeleteRequest, options?: RpcOptions): UnaryCall<ActionServiceDeleteRequest, ActionServiceDeleteResponse>;
    /**
     * Search actions
     *
     * @generated from protobuf rpc: Search
     */
    search(input: ActionServiceSearchRequest, options?: RpcOptions): UnaryCall<ActionServiceSearchRequest, ActionServiceSearchResponse>;
}
/**
 * @generated from protobuf service c1.api.action.v1.ActionService
 */
export class ActionServiceClient implements IActionServiceClient, ServiceInfo {
    typeName = ActionService.typeName;
    methods = ActionService.methods;
    options = ActionService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Create a new action
     *
     * @generated from protobuf rpc: Create
     */
    create(input: ActionServiceCreateRequest, options?: RpcOptions): UnaryCall<ActionServiceCreateRequest, ActionServiceCreateResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ActionServiceCreateRequest, ActionServiceCreateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get an action by ID
     *
     * @generated from protobuf rpc: Get
     */
    get(input: ActionServiceGetRequest, options?: RpcOptions): UnaryCall<ActionServiceGetRequest, ActionServiceGetResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ActionServiceGetRequest, ActionServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List actions
     *
     * @generated from protobuf rpc: List
     */
    list(input: ActionServiceListRequest, options?: RpcOptions): UnaryCall<ActionServiceListRequest, ActionServiceListResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ActionServiceListRequest, ActionServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update an action
     *
     * @generated from protobuf rpc: Update
     */
    update(input: ActionServiceUpdateRequest, options?: RpcOptions): UnaryCall<ActionServiceUpdateRequest, ActionServiceUpdateResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<ActionServiceUpdateRequest, ActionServiceUpdateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete an action
     *
     * @generated from protobuf rpc: Delete
     */
    delete(input: ActionServiceDeleteRequest, options?: RpcOptions): UnaryCall<ActionServiceDeleteRequest, ActionServiceDeleteResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<ActionServiceDeleteRequest, ActionServiceDeleteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Search actions
     *
     * @generated from protobuf rpc: Search
     */
    search(input: ActionServiceSearchRequest, options?: RpcOptions): UnaryCall<ActionServiceSearchRequest, ActionServiceSearchResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<ActionServiceSearchRequest, ActionServiceSearchResponse>("unary", this._transport, method, opt, input);
    }
}
